import { RouteConfigItem, Context } from 'models';

function routesNormalizer(routes: RouteConfigItem[]): RouteConfigItem[] {
  let formattedRoutes: RouteConfigItem[] = routes
    .flatMap(route => {
      const { children, ...rest } = route;

      return [rest, ...[children || []]];
    })
    .flat();

  formattedRoutes = formattedRoutes.reduce(
    (accumulator: RouteConfigItem[], route) => {
      const { children, ...rest } = route;
      const routeChildren = children
        ? routesNormalizer([rest, ...children])
        : [rest];

      accumulator = [...accumulator, ...routeChildren];

      return accumulator;
    },
    [],
  );

  return formattedRoutes;
}

export function recursiveRouter(
  routes: RouteConfigItem[],
  basePath?: string,
  context?: Context,
): RouteConfigItem[] {
  let splittedRoutes: RouteConfigItem[] = basePath
    ? routes.map(route => ({
        ...route,
        path: `${basePath}${route.path}`,
        context,
      }))
    : [...routes];
  splittedRoutes = splittedRoutes.map(route =>
    route?.children
      ? {
          ...route,
          children: recursiveRouter(route.children, route.path, route.context),
        }
      : route,
  );

  return splittedRoutes.sort((a, b) => {
    if (a.path.length > b.path.length) {
      return -1;
    }

    if (a.path.length < b.path.length) {
      return 1;
    }

    return 0;
  });
}

export function getNormalizedRoutes(
  routes: RouteConfigItem[],
  orderBy: 'id' | 'path' = 'path',
): RouteConfigItem[] {
  const decorattedRoutes = recursiveRouter(routes);
  const normalizedRoutes = routesNormalizer(decorattedRoutes);

  return normalizedRoutes.sort((routeA, routeB) => {
    if (routeA[orderBy] > routeB[orderBy]) {
      return -1;
    }

    if (routeA[orderBy] < routeB[orderBy]) {
      return 1;
    }

    return 0;
  });
}
